import { Close } from "@mui/icons-material"
import { Box, Dialog, IconButton } from "@mui/material"
import { type FC, forwardRef } from "react"

import type { ModalProps } from "./modal.types"

export const Modal: FC<ModalProps> = forwardRef(
	(
		{
			width = 600,
			onClose,
			children,
			showCloseIcon = true,
			fullWidth = true,
			...props
		},
		ref,
	) => (
		<Dialog ref={ref} onClose={onClose} {...props} fullWidth>
			<Box
				width='100%'
				data-testid='modal'
				position='relative'
				maxWidth={width}
			>
				{showCloseIcon && (
					<IconButton
						size='small'
						onClick={onClose}
						data-testid='closeModal'
						sx={{ position: "absolute", right: 8, top: 8 }}
					>
						<Close />
					</IconButton>
				)}

				<Box p={3.75}>{children}</Box>
			</Box>
		</Dialog>
	),
)
